let i = 0,
    scrollVal = 0,
    cookieBanner = '',
    vidR = 16/9,
    winW = 0,
    winH = 0,
    winR = 0,
    carouselCurrent = 1,
    carouselTotal = 4,
    carouselTime = 5,
    currentLogoAnimation = 1;

const logoAnimation = 60,
      fps = Math.round(1000/32);

function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function carouselTick(){
    carouselCurrent++;
    if (carouselCurrent > carouselTotal) {
        carouselCurrent = 1;
    }
    document.getElementById('movement-hero').className = 'pos-'+carouselCurrent;
}

function setupAccordion(){
    const scw = document.getElementById('stay-connected-wrap');

    if (scw) {
        const scwlinks = document.querySelectorAll('#stay-connected-wrap nav a');
        for(i=0; i<scwlinks.length; i++){
	           scwlinks[i].addEventListener('click', function(e){
                   document.getElementById('stay-connected-wrap').className = this.getAttribute('data-section');
                   e.preventDefault();
               });
	    }
    }
}

function closeModal(e){
    document.getElementById('modal-content').innerHTML = '';
    document.body.classList.remove('page-modal');
    e.preventDefault();
}


function setVideoModalSize(){
    let w = Math.round(winW * 0.9),
        h = Math.round(w / vidR);

    //alert();
    if((h+105) > winH) {
        h = winH-105;
        w = Math.round(h * vidR);
    }

    const ml = Math.round((winW-w) * 0.5),
          mt = Math.round((winH-h) * 0.5);

    document.getElementById('modal-content').style.width = w + 'px';
    document.getElementById('modal-content').style.marginLeft = ml + 'px';
    document.getElementById('modal-content').style.height = h + 'px';
    document.getElementById('modal-content').style.marginTop = mt + 'px';

    document.getElementById('modal-close').style.right = ml + 'px';
    document.getElementById('modal-close').style.top = (mt-53) + 'px';
    //winW = window.innerWidth;
    //winH = window.innerHeight;
}


function openVideoModal(vidid){

    document.body.classList.add('page-modal');
    document.getElementById('modal-content').innerHTML = '<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/'+vidid+'?badge=0&amp;autopause=0&amp;autoplay=1&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="last_will_v05.mp4"></iframe></div>';

    setVideoModalSize();
}

function sendStayInTouchForm(email, phone){
    const request = new XMLHttpRequest();
    request.open('GET', '/proc-send.php?email='+ email +'&phone=' + phone);
    request.onreadystatechange = function() {
        if(this.readyState === 4 && this.status === 200) {
            // Any response needed, follow up here.
        }
    };
    request.send();
}

function setupStayInTouch(){
    if (document.getElementById('stay-in-touch')) {

        document.getElementById('email-send').addEventListener('focus', function(e){
            this.parentNode.classList.remove('error');
        });
        document.getElementById('phone-send').addEventListener('focus', function(e){
            this.parentNode.classList.remove('error');
        });

        document.querySelector('#email-line a').addEventListener('click', function(e){
            const el = document.getElementById('email-send');
            if (validateEmail(el.value) == false) {
                el.parentNode.classList.add('error');
            } else {
                document.getElementById('email-line').classList.add('success');
                sendStayInTouchForm(el.value, '');
            }
            e.preventDefault();
        });

        document.querySelector('#phone-line a').addEventListener('click', function(e){
            const el = document.getElementById('phone-send');
            if(el.value == ''){
                el.parentNode.classList.add('error');
            } else {
                document.getElementById('phone-line').classList.add('success');
                sendStayInTouchForm('', el.value);
            }
            e.preventDefault();
        });
    }
}


window.addEventListener('resize', function(e) {
    winW = window.innerWidth;
    winH = window.innerHeight;
    winR = winW/winH;


    if (document.querySelector('#modal-content iframe')) {
        setVideoModalSize();
    }
    //document.getElementById('modal-content').innerHTML = '';
    //document.body.classList.remove('page-modal');
});

window.addEventListener('scroll', function(e) {
    scrollVal = (document.documentElement.scrollTop) ? document.documentElement.scrollTop : document.body.scrollTop;
    if(scrollVal > 60) {
        document.body.classList.add('scroll');
    } else {
        document.body.classList.remove('scroll');
    }
});

function setupLogoAnimation(){

    if(document.querySelector('main h1')){
        setTimeout(itterateLogo, 500);
    }
}

function itterateLogo(){
    document.querySelector('main h1').className = 'logo-' + currentLogoAnimation;

    currentLogoAnimation++;

    if(currentLogoAnimation <= logoAnimation){
        setTimeout(itterateLogo, fps);
    }
}


document.addEventListener('DOMContentLoaded', function(){

    setupLogoAnimation();

    document.body.classList.add('loaded');

    winW = window.innerWidth;
    winH = window.innerHeight;
    winR = winW/winH;

    const extl = document.querySelectorAll('.external');
    for(i = 0; i < extl.length; i++){ extl[i].setAttribute('target', '_blank'); }

    const vl = document.querySelectorAll('.vid-link');
    for(i = 0; i < vl.length; i++){
        vl[i].addEventListener('click', function(e){
            openVideoModal(this.getAttribute('data-id'));
            e.preventDefault();
        });
    }

    if(document.getElementById('create-your-will')){
        createYourWillForm();
    }

    if(document.getElementById('movement-hero')) {
        setInterval(carouselTick, (carouselTime*1000));
    }

    document.getElementById('mobile-toggle').addEventListener('click', function(e){
        document.body.classList.toggle('mobile-open');
        e.preventDefault();
    });

    document.getElementById('modal-bg').addEventListener('click', closeModal);
    document.getElementById('modal-close').addEventListener('click', closeModal);

    //set

    createWillGallery()
    //setupStayInTouch();
    setupAccordion();
});
